<template>
    <div class="userInfoWidget" :key="activeConversation._id">
        <div id="chatCard">
            <div class="headtitle">
                <span class="text">{{ $t("userInfoWidget.userInformation") }}</span>
                <span class="ml-4"
                    ><button class="classic-button" @click="newEventModalVisible = true">
                        {{ $t("message.addCalendarEvent") }}
                    </button>
                </span>
                <span class="ml-4"
                    ><button
                        class="classic-button"
                        @click="() => this.$router.push(`visitors/${activeConversation.visitor._id}`)"
                    >
                        {{ $t("message.userProfile") }}
                    </button>
                </span>
            </div>

            <div class="details-chat-card">
                <div v-if="getSubjectName(activeConversation.subject)" class="user-detail">
                    <span class="icon material-icons">sell</span>

                    <div class="flex w-full centered space-between">
                        <span>
                            {{ getSubjectName(activeConversation.subject) }}
                        </span>
                        <button
                            @click="copyTextToClipboard(getSubjectName(activeConversation.subject) || 'N/A')"
                            class="copyButton"
                        >
                            <a-icon type="copy" />
                        </button>
                    </div>
                </div>
                <div class="user-detail">
                    <span
                        class="icon material-icons"
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :content="$t('userInfoWidget.fullName')"
                        >person</span
                    >
                    <div class="input-value">
                        <div class="edited-input" v-if="editVisitorProperty == 'visitorUsenameInput'">
                            <a-input
                                class="mr-1"
                                v-model="editVisitorPropertyValue"
                                @mouseleave="editVisitorProperty = null"
                                @change="changeVisitorUsername()"
                            >
                            </a-input>
                        </div>
                        <div
                            class="w-full"
                            @mouseover="
                                editVisitorProperty = 'visitorUsenameInput';
                                editVisitorPropertyValue = activeConversation.fullname || '';
                            "
                            v-else
                        >
                            {{ activeConversation.fullname || "N/A" }}
                        </div>
                        <div>
                            <ActionEdit
                                v-tippy="{
                                    followCursor: true,
                                    placement: 'bottom-end',
                                    theme: isDarkMode ? 'light-border' : 'google',
                                }"
                                :content="$t('userInfoWidget.clickToEdit')"
                                height="11"
                                style="font-size: 10px !important"
                                width="11"
                            />
                            <button
                                @click="copyTextToClipboard(activeConversation.fullname || 'N/A')"
                                class="copyButton"
                            >
                                <a-icon type="copy" />
                            </button>
                        </div>
                    </div>
                </div>
                <div class="user-detail">
                    <span
                        class="icon material-icons"
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :content="$t('coupon.email')"
                        >mail</span
                    >
                    <div class="input-value">
                        <div class="edited-input" v-if="editVisitorProperty == 'visitorEmailInput'">
                            <a-input
                                class="mr-1"
                                v-model="editVisitorPropertyValue"
                                @mouseleave="editVisitorProperty = null"
                                @change="changeVisitorEmail()"
                            >
                            </a-input>
                        </div>
                        <div
                            class="w-full"
                            @mouseover="
                                editVisitorProperty = 'visitorEmailInput';
                                editVisitorPropertyValue = activeConversation.email || '';
                            "
                            v-else
                        >
                            {{ activeConversation.email === "" ? "N/A" : activeConversation.email }}
                        </div>
                        <div>
                            <ActionEdit
                                v-tippy="{
                                    followCursor: true,
                                    placement: 'bottom-end',
                                    theme: isDarkMode ? 'light-border' : 'google',
                                }"
                                :content="$t('userInfoWidget.clickToEdit')"
                                height="11"
                                style="font-size: 10px !important"
                                width="11"
                            />
                            <button @click="copyTextToClipboard(activeConversation.email || 'N/A')" class="copyButton">
                                <a-icon type="copy" />
                            </button>
                        </div>
                    </div>
                </div>
                <div class="user-detail">
                    <span
                        class="icon material-icons"
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :content="$t('message.language')"
                        >language</span
                    >
                    <div class="flex centered space-between w-full" v-if="selectedLang">
                        <div class="lang-info input-value" @click="isVisibleLangModal = true">
                            <div>
                                {{ selectedLang.originalName }}
                            </div>
                            <ActionEdit
                                v-tippy="{
                                    followCursor: true,
                                    placement: 'bottom-end',
                                    theme: isDarkMode ? 'light-border' : 'google',
                                }"
                                :content="$t('userInfoWidget.clickToEdit')"
                                height="11"
                                style="font-size: 10px !important"
                                width="11"
                            />
                        </div>
                        <button @click="copyTextToClipboard(selectedLang.originalName || 'N/A')" class="copyButton">
                            <a-icon type="copy" />
                        </button>
                    </div>
                    <Modal2
                        v-if="isVisibleLangModal"
                        :title="$t('message.languageSelection')"
                        @cancel="isVisibleLangModal = false"
                        :show-footer="false"
                    >
                        <div class="d-flex flex-column">
                            <a-select
                                v-model="activeConversation.visitor.preferredLang"
                                class="my-2"
                                show-search
                                option-filter-prop="children"
                                :filter-option="filterOption"
                                :autofocus="true"
                            >
                                <a-select-option v-for="lang in languages" :key="lang.code" :value="lang.code">
                                    {{ lang.originalName }}
                                </a-select-option>
                            </a-select>
                            <b-button size="sm" variant="success" @click="updateVisitorLang">
                                {{ $t("message.save") }}
                            </b-button>
                        </div>
                    </Modal2>
                </div>
                <div
                    class="user-detail"
                    v-if="
                        Array.isArray(activeConversation.customLoginInfos) && activeConversation.customLoginInfos.length
                    "
                    v-for="(inputValue, index) of getCustomLoginInfos()"
                    :key="inputValue.id"
                >
                    <span
                        class="icon material-icons"
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :content="inputValue.name"
                        >alternate_email</span
                    >

                    <div class="input-value">
                        <div :ref="`${inputValue.id}`" class="edited-input" v-if="editVisitorProperty == inputValue.id">
                            <a-input
                                class="mr-1"
                                v-model="editVisitorPropertyValue"
                                @mouseleave="editVisitorProperty = null"
                                @change="changeCustomLogin()"
                            >
                            </a-input>
                        </div>
                        <div
                            class="w-full"
                            @mouseover="
                                editVisitorProperty = inputValue.id;
                                editVisitorPropertyValue = inputValue.value || '';
                            "
                            v-else
                        >
                            {{ inputValue.value || "N/A" }}
                        </div>
                        <div>
                            <ActionEdit
                                v-tippy="{
                                    followCursor: true,
                                    placement: 'bottom-end',
                                    theme: isDarkMode ? 'light-border' : 'google',
                                }"
                                :content="$t('userInfoWidget.clickToEdit')"
                                height="11"
                                style="font-size: 10px !important"
                                width="11"
                            />
                            <button @click="copyTextToClipboard(inputValue.value || 'N/A')" class="copyButton">
                                <a-icon type="copy" />
                            </button>
                        </div>
                    </div>
                </div>
                <div
                    class="user-detail"
                    v-if="visitor"
                    v-for="attr of ((visitor && visitor.contactProperties) || []).filter((x) => x.property)"
                    :key="attr._id"
                >
                    <span
                        class="icon material-icons"
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :content="attr.property.label"
                        >data_object</span
                    >

                    <span style="font-weight: bold; font-size: 14px; width: 100px" :content="attr.property.label"
                        >{{ attr.property.label }}:</span
                    >
                    <div class="input-value">
                        <div class="edited-input" v-if="editVisitorProperty == attr.property._id">
                            <a-input
                                class="mr-1"
                                v-model="editVisitorPropertyValue"
                                @mouseleave="editVisitorProperty = null"
                                @change="changeVisitorAttr()"
                            >
                            </a-input>
                        </div>
                        <div
                            class="w-full"
                            @mouseover="
                                editVisitorProperty = attr.property._id;
                                editVisitorPropertyValue = attr.value;
                            "
                            v-else
                        >
                            {{ attr.value || "N/A" }}
                        </div>
                    </div>
                    <div class="flex centered">
                        <button @click="removeVisitorAttr(attr._id)" class="removeButton">
                            <a-icon type="delete" />
                        </button>
                        <button @click="copyTextToClipboard(attr.value || 'N/A')" class="copyButton">
                            <a-icon type="copy" />
                        </button>
                    </div>
                </div>
                <div class="user-detail">
                    <span class="material-icons icon">add</span>
                    <button class="classic-button visitor-attr" @click="addNewAttribue = true">
                        {{ $t("userInfoWidget.newValue") }}
                    </button>
                    <Modal2
                        v-if="addNewAttribue"
                        :title="$t('userInfoWidget.newProfileInfo')"
                        @cancel="addNewAttribue = false"
                        :show-footer="false"
                    >
                        <div class="d-flex flex-column">
                            <h6 style="font-size: 14px; color: #000 !important">
                                {{ $t("userInfoWidget.newProfileInfo") }}
                            </h6>
                            <div>Contact Property</div>
                            <a-select
                                v-model="newAttributeForm.key"
                                class="my-2"
                                show-search
                                option-filter-prop="children"
                                :filter-option="filterOption"
                                :autofocus="true"
                            >
                                <a-select-option
                                    v-for="(attr, index) in visitorAttributes"
                                    :key="index"
                                    :value="attr._id"
                                >
                                    {{ attr.label }}
                                </a-select-option>
                                <a-select-option key="new" value="new"> New Property</a-select-option>
                            </a-select>
                            <div v-if="newAttributeForm.key == 'new'">Label</div>
                            <a-input
                                v-if="newAttributeForm.key == 'new'"
                                v-model="newAttributeForm.newKey"
                                class="mb-2"
                            ></a-input>
                            <div v-if="newAttributeForm.key">Value</div>
                            <a-input v-if="newAttributeForm.key" v-model="newAttributeForm.value"></a-input>
                            <div style="display: flex; justify-content: end">
                                <b-button
                                    class="classic-button mt-2"
                                    size="sm"
                                    variant="success"
                                    @click="createVisitorAttribute"
                                >
                                    {{ $t("message.save") }}
                                </b-button>
                            </div>
                        </div>
                    </Modal2>
                </div>
            </div>
        </div>
        <VisitorMetaReferralsCard
            :metaReferrals="visitor.metaReferrals"
            v-if="$_.get(visitor, 'metaReferrals', []).length > 0"
        />
        <VisitorCalendarCard
            :visitorId="activeConversation.visitor._id"
        />
        <div id="chatCard">
            <div class="headtitle">
                <span class="text">{{ $t("userInfoWidget.affiliatedRepresentatives") }} </span>

                <div v-if="!observing.includes(activeConversation._id)" class="d-flex flex-row">
                    <a-button
                        ghost
                        @click="openDelegateAssignment"
                        class="justify-content-around pl-3 popoverFont cursorPointer"
                        id="forwardButton"
                    >
                        <font-awesome-icon icon="share" style="margin-right: 5px" />
                        {{ $t("message.forwardRep") }}
                    </a-button>
                </div>
                <Modal2
                    id="Modal2"
                    v-if="modalDelegateAssignment"
                    :title="$t('message.forwardRepresentative')"
                    @cancel="modalDelegateAssignment = false"
                    :show-footer="false"
                    class-name="forwardRepresentativeModal"
                >
                    <AgentList
                        :forward="true"
                        :show-online-agents="true"
                        @closeModal="modalDelegateAssignment = false"
                    />
                </Modal2>
                <a-button
                    ghost
                    v-if="observing.includes(activeConversation._id)"
                    @click="joinTheChat(activeConversation)"
                    class="justify-content-around pl-3 popoverFont cursorPointer"
                    id="joinButton"
                    >{{ $t("message.joinChat") }}
                </a-button>
            </div>
            <div style="display: flex; align-items: center">
                <a-tag
                    color="orange"
                    class="user-detail-name"
                    v-for="user of getAgentNames(activeConversation)"
                    :key="user"
                    v-tippy="{ followCursor: true, placement: 'bottom-start' }"
                    :content="user"
                >
                    {{ user || "" }}
                </a-tag>
            </div>
        </div>
        <div id="chatCard">
            <div class="headtitle">
                <span class="text">{{ $t("userInfoWidget.preferredAgents") }}</span>
            </div>
            <PreferredAgents v-if="visitor" :visitorId="visitor._id" v-model="visitor.preferredAgents" />
        </div>
        <div id="chatCard">
            <div class="headtitle">
                <span class="text">{{ $t("userInfoWidget.labels") }}</span>
            </div>
            <span>
                <TagDialog v-model="tags" :hide-add="false" />
            </span>
        </div>
        <div id="chatCard">
            <div class="headtitle">
                <span class="text">{{ $t("userInfoWidget.agentNotes") }}</span>
                <span class="ml-4"
                    ><button v-if="!isNewNot" class="classic-button" @click="isNewNot = true">
                        {{ $t("userInfoWidget.newNote") }}
                    </button>
                </span>
            </div>

            <div class="rep-note-element mt-2" v-if="isNewNot">
                <a-textarea v-model="info" class="disableShortcut" />
                <div class="rep-note-actions mt-1">
                    <a-button-group size="small">
                        <a-button class="classic-button mr-1" icon="close" type="danger" @click="notSaveInfo" />
                        <a-button
                            class="classic-button"
                            style="color: rgb(38, 233, 38)"
                            icon="check"
                            type="primary"
                            @click="saveInfo"
                        />
                    </a-button-group>
                </div>
            </div>
            <div class="old-note" v-if="lastNote" @click="oldNoteIsOpen = !oldNoteIsOpen">
                <button class="classic-button open-note">
                    <span class="material-icons icon">{{ oldNoteIsOpen ? "remove" : "add" }}</span>
                </button>
                <span class="information"><b>1</b> {{ $t("userInfoWidget.available") }}</span>
            </div>
            <div v-if="oldNoteIsOpen" class="old-note-desc">
                <div class="top-header">
                    <div class="agent-name">{{ lastNote.representativeName }}</div>
                    <div
                        class="old-note-date"
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :content="$moment(lastNote.createdAt).format('LLL')"
                    >
                        {{ lastNote.createdAt && $moment(lastNote.createdAt).fromNow() }}
                    </div>
                </div>
                <div class="agent-note">{{ lastNote.representativeNote }}</div>
            </div>
        </div>
        <div id="chatCard">
            <div class="headtitle">
                <span class="text">{{ $t("userInfoWidget.systemInformation") }}</span>
            </div>
            <div class="details-chat-card">
                <div class="user-detail">
                    <span
                        class="icon material-icons"
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :content="$t('userInfoWidget.speechID')"
                        >badge</span
                    >
                    <span>{{ activeConversation._id }}</span>
                </div>
                <div class="user-detail">
                    <span
                        class="icon material-icons"
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :content="$t('userInfoWidget.customerVersion')"
                        >info</span
                    >
                    <span>
                        {{
                            (
                                this.activeConversation.visitor.version || {
                                    version: -1,
                                    versionStr: "N/A",
                                    buildNumber: -1,
                                    commitHash: "",
                                }
                            ).versionStr
                        }}
                    </span>
                </div>
                <div class="user-detail" v-if="!isSocialMediaChat()">
                    <span
                        class="icon material-icons"
                        v-tippy="{ followCursor: true, placement: 'bottom-end' }"
                        :content="$t('userInfoWidget.IPAddress')"
                        >computer</span
                    >
                    <span>
                        {{ activeConversation.ipAddress }}
                    </span>
                    <!--                    <span v-else-if="activeConversation.ref === 'whatsapp'">
                                            <md-icon style="color: #06e576; margin-left: 10px; font-size: 11px"> whatsapp </md-icon>
                                        </span>
                                        <span style="width: 30px; height: 30px" v-if="activeConversation.ref === 'instagram'">
                                            <InstagramIcon :width="30" :height="30" />
                                        </span>-->
                </div>

                <div class="user-detail" v-if="getChannelName()">
                    <WhatsappV1
                        v-if="getChannelType() === 'whatsapp-v1'"
                        class="whatsapp-channel-info"
                        :color="'#179d0d'"
                    />
                    <WhatsappV2
                        v-if="getChannelType() === 'whatsapp-v2'"
                        class="whatsapp-channel-info"
                        :color="'#179d0d'"
                    />
                    <WhatsappBusinessIcon
                        v-if="getChannelType() === 'whatsapp-business-api'"
                        class="whatsapp-channel-info"
                        :color="'#179d0d'"
                    />
                    <span>
                        {{ getChannelName() }}
                    </span>
                </div>
                <div class="user-detail" v-if="getChannelName()">
                    <PhoneIcon class="whatsapp-channel-info" />
                    <span id="user-phone-number">
                        <a :href="'tel:' + getChannelNumber()">{{ getChannelNumber() }}</a>
                    </span>
                </div>
                <div class="user-detail">
                    <span
                        class="icon material-icons"
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :content="$t('userInfoWidget.pageVisited')"
                        >public</span
                    >
                    <span style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
                        <a
                            v-if="activeConversation.visitingPage"
                            :href="activeConversation.visitingPage ? activeConversation.visitingPage : '#'"
                            class="info-label"
                            target="_blank"
                            >{{ activeConversation.visitingPage }}</a
                        >
                        <span v-else>N/A</span>
                    </span>
                </div>
                <div class="user-detail">
                    <span
                        class="icon material-icons"
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :content="$t('userInfoWidget.systemAndBrowser')"
                        >settings_suggest</span
                    >
                    <span v-if="!isSocialMediaChat()">
                        <span v-if="activeConversation.visitor.os && activeConversation.visitor.browser"
                            >{{ activeConversation.visitor.os }} / {{ activeConversation.visitor.browser }}</span
                        >
                        <span v-else> {{ getUserDetailedLoginInfo(activeConversation.userAgent) }}</span>
                    </span>
                    <span v-else>{{
                        (
                            this.activeConversation.visitor.version || {
                                version: -1,
                                versionStr: "N/A",
                                buildNumber: -1,
                                commitHash: "",
                            }
                        ).versionStr
                    }}</span>
                </div>
                <div class="user-detail">
                    <span
                        class="icon material-icons"
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :content="$t('userInfoWidget.countryAndLanguage')"
                        >map</span
                    >
                    <div class="d-flex" style="align-items: center">
                        <country-flag
                            v-if="
                                getCountryCode(
                                    $_.get(activeConversation, 'geoLocation.country') || activeConversation.languageCode
                                )
                            "
                            v-tippy="{
                                followCursor: true,
                                placement: 'bottom-end',
                                theme: isDarkMode ? 'light-border' : 'google',
                            }"
                            :content="
                                getCountryName(
                                    $_.get(activeConversation, 'geoLocation.country') || activeConversation.languageCode
                                )
                            "
                            :country="
                                getCountryCode(
                                    $_.get(activeConversation, 'geoLocation.country') || activeConversation.languageCode
                                )
                            "
                            size="normal"
                            style="margin-top: -8px"
                        />
                        <span
                            v-else
                            v-tippy="{
                                followCursor: true,
                                placement: 'bottom-end',
                                theme: isDarkMode ? 'light-border' : 'google',
                            }"
                            :content="
                                getCountryName(
                                    $_.get(activeConversation, 'geoLocation.country') || activeConversation.languageCode
                                )
                            "
                        >
                            {{ activeConversation.geoLocation ? activeConversation.geoLocation.country : "N/A" }}
                        </span>

                        <span style="margin-left: 5px">
                            {{ activeConversation.languageCode.toUpperCase() }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
        <CreateEventModal
            :calendarList="calendarList"
            v-if="newEventModalVisible"
            @close="newEventModalVisible = false"
            :refVisitor="activeConversation.visitor._id"
        />
    </div>
</template>

<script>
import Vue from "vue";
import { mapActions, mapGetters, mapState } from "vuex";
import Representative from "./svg/Representative";
import SendIcon from "./svg/SendIcon";
import ChatId from "./svg/ChatId";
import Operating from "./svg/Operating";
import World from "./svg/World";
import Ip from "./svg/Ip";
import User from "./svg/User";
import Mail from "./svg/Mail";
import KeywordShortCut from "./svg/KeywordShortCut";
import ConversationColor from "./svg/ConversationColor";
import { log2 } from "../utils/log2";
import CountryFlag from "vue-country-flag";
import countryCodes from "../utils/countryCodes";
import { i18n } from "../language";
import ClipboardList from "./svg/ClipboardList";
import Language from "./svg/Language";
import Earth from "./svg/Earth";
import UserName from "./svg/UserName";
import Version from "./svg/Version";
import { capitalize, fakeConversation, validateEmail } from "../utils/utils";
import { sendSocketMessage } from "../utils/socketStream";
import ActionEdit from "./svg/ActionEdit";
import $_ from "lodash";
import _ from "lodash";
import CONFIG from "../config/config";
import { getPersistenceData } from "../utils/persistenceStorage";
import languages from "../language/languages.json";
import TagDialog from "./TagDialog";
import PreferredAgents from "./PreferredAgents.vue";
import InstagramIcon from "./svg/InstagramIcon";
import Modal2 from "./common/Modal2.vue";
import ForwardRepresentative from "./svg/ForwardRepresentative.vue";
import AgentList from "./AgentList.vue";
import WhatsappIcon from "../views/Pages/Chatbot/pages/integrations/svg/WhatsappIcon.vue";
import WhatsappV2 from "../views/Pages/Chatbot/pages/integrations/svg/specialWhatsappIcon/WhatsappV2.vue";
import WhatsappV1 from "../views/Pages/Chatbot/pages/integrations/svg/specialWhatsappIcon/WhatsappV1.vue";
import WhatsappBusinessIcon from "../views/Pages/Chatbot/pages/integrations/svg/WhatsappBusinessIcon.vue";
import PhoneIcon from "../views/Pages/Chatbot/pages/integrations/svg/PhoneIcon.vue";
import VisitorMetaReferralsCard from "./visitor/VisitorMetaReferralsCard.vue";
import VisitorCalendarCard from "./visitor/VisitorCalendarCard.vue";
import CreateEventModal from "../views/Pages/Calendar/Component/CreateEventModal.vue";

Vue.component("country-flag", CountryFlag);
const log = log2("UserInfoWidget");
export default {
    name: "UserInfoWidget",
    components: {
        CreateEventModal,
        TagDialog,
        Representative,
        SendIcon,
        ChatId,
        Operating,
        World,
        Ip,
        User,
        Mail,
        KeywordShortCut,
        ConversationColor,
        ClipboardList,
        Language,
        Earth,
        UserName,
        Version,
        ActionEdit,
        InstagramIcon,
        PreferredAgents,
        Modal2,
        ForwardRepresentative,
        AgentList,
        WhatsappIcon,
        WhatsappV2,
        WhatsappV1,
        WhatsappBusinessIcon,
        PhoneIcon,
        VisitorMetaReferralsCard,
        VisitorCalendarCard,
    },
    data() {
        return {
            isCardVisible: true,
            newEventModalVisible: false,
            modalDelegateAssignment: false,
            languages,
            info: "",
            noteSender: "",
            conversationId: "",
            visitorEmailInputActive: false,
            visitorNameInputActive: false,
            $_,
            renderCount: 0,
            userInfoActiveInputs: {},
            isVisibleLangModal: false,
            selectedLang: {},
            visitor: null,
            lastNote: null,
            addNewAttribue: false,
            isNewNot: false,
            oldNoteIsOpen: false,
            newAttributeForm: {
                newKey: null,
                key: null,
                value: null,
            },
            editVisitorProperty: null,
            editVisitorPropertyValue: null,
            editVisitorTimer: null,
        };
    },
    mounted() {
        this.selectedLang = languages.find((lang) => lang.code === this.activeConversation?.visitor?.preferredLang);
        if (this.activeConversation.note) {
            this.conversationId = this.activeConversation._id;
        }
        this.getVisitorFromId(this.activeConversation.visitor._id);
        this.getLastNote(this.activeConversation.visitor._id).then((note) => {
            this.lastNote = note;
        });
    },
    computed: {
        ...mapGetters({
            isDarkMode: "user/isDarkMode",
        }),
        ...mapState({
            calendarList: (state) => state.calendar.calendarList,
            channels: (state) => state.channel.channels,
            site: (state) => state.site.site,
            contacts: (state) => state.whatsapp.contacts,
            user: (state) => state.auth.user,
            users: (state) => state.user.users.data,
            activeConversation: (state) =>
                state.app.fakeMode ? state.chat.fakeActiveConversation : state.chat.activeConversation,
            subjects: (state) => state.subject.subjects.data,
            inputs: (state) =>
                state.customLoginForm.inputs.reduce((acc, cur) => {
                    acc[cur._id] = cur;
                    return acc;
                }, {}),
            visitorAttributes: (state) => state.contactProperty.data || [],
            observing: (state) => state.chat.observing,
        }),
        tags: {
            get() {
                const isExitsTagIds = $_.get(this.activeConversation.visitor, "tags", []).map((tag) => {
                    if (typeof tag === "object") {
                        return true;
                    }
                    return false;
                });
                if (isExitsTagIds[0]) {
                    return $_.get(this.activeConversation.visitor, "tags", []).map((tag) => tag._id);
                }
                return $_.get(this.activeConversation.visitor, "tags", []);
            },
            set: $_.debounce(function (v) {
                this.updateVisitorTags({
                    conversationId: this.activeConversation._id,
                    visitorId: this.activeConversation.visitor._id,
                    tagIds: v,
                }).then(() => {
                    sendSocketMessage("visitor profile-updated", {
                        siteId: this.site._id,
                        visitorId: this.activeConversation.visitor._id,
                        updatingFields: ["tags"],
                    });
                });
            }, 300),
        },
    },
    updated() {
        log("updated", this.activeConversation);
        if (this.conversationId !== this.activeConversation._id) {
            this.info = this.activeConversation.note.representativeNote;
            this.noteSender = this.activeConversation.note.representativeName;
            this.conversationId = this.activeConversation._id;
        }
    },
    created() {
        log("created", this.activeConversation);
    },
    methods: {
        ...mapActions({
            addNoteToConversation: "chat/addNoteToConversation",
            updateTags: "chat/updateTags",
            updateCustomLoginInfo: "chat/updateCustomLoginInfo",
            getVisitor: "visitor/getVisitor",
            createContactProperty: "visitor/createContactProperty",
            deleteContactProperty: "visitor/deleteContactProperty",
            getLastNote: "visitor/getLastNote",
            joinConversation: "chat/joinConversation",
            multiBeepConversation: "chat/multiBeepConversation",
            viewFakeConversation: "chat/viewFakeConversation",
            createNewContactProperty: "contactProperty/createContactProperty",
            updateVisitorTags: "chat/updateVisitorTags",
        }),
        isSocialMediaChat() {
            return !!this.activeConversation.whatsappNumber || !!this.activeConversation.instagramUserId;
        },
        getChannelName() {
            const result = this.channels.find((channel) => channel._id === this.activeConversation.channel);
            return result?.name;
        },
        getChannelType() {
            const result = this.channels.find((channel) => channel._id === this.activeConversation.channel);
            return result.type;
        },
        getChannelNumber() {
            const phone = this.activeConversation?.visitor?.whatsappNumber;
            return phone ? "+" + phone : null;
        },
        changeVisitorAttr() {
            if (this.editVisitorTimer) clearTimeout(this.editVisitorTimer);
            const key = this.editVisitorProperty;
            const val = this.editVisitorPropertyValue;
            this.editVisitorTimer = setTimeout(() => {
                this.createContactProperty({
                    visitorId: this.activeConversation.visitor._id,
                    payload: {
                        property: key,
                        value: val,
                    },
                }).then((res) => {
                    const index = this.visitor.contactProperties.findIndex((c) => c._id == res._id);
                    if (index < 0) {
                        this.visitor.contactProperties = [...this.visitor.contactProperties, res];
                    } else {
                        this.visitor.contactProperties.splice(index, 1, res);
                    }
                    this.$message.success(this.$t("chatbotv2.saveSuccessfully"));
                });
            }, 500);
        },
        createVisitorAttribute() {
            (this.newAttributeForm.newKey
                ? this.createNewContactProperty({
                      name: this.newAttributeForm.newKey,
                      label: this.newAttributeForm.newKey,
                      type: "text",
                  })
                : Promise.all([])
            ).then((newContactProperty) => {
                this.createContactProperty({
                    visitorId: this.activeConversation.visitor._id,
                    payload: {
                        property: this.newAttributeForm.newKey ? newContactProperty._id : this.newAttributeForm.key,
                        value: this.newAttributeForm.value,
                    },
                }).then((res) => {
                    const index = this.visitor.contactProperties.findIndex((c) => c._id == res._id);
                    if (index < 0) {
                        this.visitor.contactProperties = [...this.visitor.contactProperties, res];
                    } else {
                        this.visitor.contactProperties.splice(index, 1, res);
                    }
                });
                this.addNewAttribue = false;
                this.newAttributeForm.key = null;
                this.newAttributeForm.newKey = null;
                this.newAttributeForm.value = null;
                this.addNewAttribue = false;
            });
        },
        updateVisitorLang() {
            sendSocketMessage("visitor lang-change", {
                visitorId: this.activeConversation.visitor._id,
                siteId: this.site._id,
                preferredLang: this.activeConversation.visitor.preferredLang,
                conversationId: this.conversationId,
            });
            this.selectedLang = languages.find((lang) => lang.code === this.activeConversation?.visitor?.preferredLang);
            this.isVisibleLangModal = false;
        },
        getVisitorAvatarSrc() {
            if (this.activeConversation.whatsappNumber) {
                return `${CONFIG.WHATSAPP.avatarAddress}?contactId=${this.activeConversation.whatsappNumber}&siteId=${
                    this.site._id
                }&token=${getPersistenceData("Admin-Token")}&r=${Math.random() * 1000}`;
            } else if (this.activeConversation.instagramUserId) {
                return `https://static.supsis.live/${this.site._id}/instagram/avatar/${this.activeConversation.instagramUserId}.jpg`;
            }
            return undefined;
        },
        getAgentNames(chat) {
            return chat.users.map((id) => {
                const u = this.users.find((x) => x._id === id);
                return u ? u.name : "";
            });
        },
        getCustomLoginInfos() {
            let inputValues = this.activeConversation.customLoginInfos || [];
            log.info("contactProperties", this.visitor);
            const hashMapContactProperty = (this.visitor?.contactProperties || []).reduce((a, b) => {
                a[b.property._id] = true;
                return a;
            }, {});

            inputValues = inputValues
                .filter((x) => this.inputs[x.input])
                .filter((x) => !["email", "fullname", "subject"].includes(this.inputs[x.input].type))
                .filter((x) => !hashMapContactProperty[this.inputs[x.input]?.contactProperty])
                .map((v) => {
                    const current = this.inputs[v.input];
                    const langs = Object.keys(_.get(current, "localizedLabel", {}));
                    const lang = langs.includes(this.$i18n.locale) ? this.$i18n.locale : langs[0];
                    const name = _.get(current, `localizedLabel.${lang}.text`, "");
                    const isSubject = _.get(current, "type") === "subject";
                    return {
                        value: isSubject ? this.getSubjectName(v.value) : v.value,
                        name,
                        id: _.get(current, "_id"),
                    };
                });
            return inputValues;
        },
        getSubjectName(id) {
            let maybeSubject = this.subjects.find((x) => x._id == id);
            return maybeSubject ? maybeSubject.languageContent[i18n.locale].name : undefined;
        },
        filterOption(input, option) {
            return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
        },
        getUserDetailedLoginInfo(uaString) {
            const parser = require("ua-parser-js");
            const ua = parser(uaString || "-");
            return `${ua.os.name} ${ua.os.version} | ${ua.browser.name} ${ua.browser.major}`;
        },
        copyTextToClipboard(str) {
            const el = document.createElement("textarea");
            el.value = str;
            document.body.appendChild(el);
            el.select();
            document.execCommand("copy");
            document.body.removeChild(el);
            this.$message.success(this.$t("message.copiedClipboard"));
        },
        getCountryCode(country) {
            country = country.trim().toLowerCase();
            if (country.length <= 3) {
                return country;
            } else {
                const maybeCounty = countryCodes.find((x) => x.name.toLowerCase().trim() === country);
                return maybeCounty ? maybeCounty.code : undefined;
            }
        },
        getCountryName(country = "") {
            const q = country.toLowerCase().trim();
            const maybeCountry = countryCodes.find(
                (x) => x.name.toLowerCase().trim() === q || x.code.toLowerCase().trim() === q
            );
            return maybeCountry ? maybeCountry.name : country;
        },
        saveInfo() {
            let payload = {
                id: this.activeConversation._id,
                representativeNote: this.info,
                representativeName: this.user.name,
            };
            log("save info", payload);
            this.addNoteToConversation(payload).then((response) => {
                this.isNewNot = false;
                this.lastNote = this.activeConversation.note;
                this.info = null;
                this.oldNoteIsOpen = true;
            });
        },
        notSaveInfo() {
            this.info = this.activeConversation.note.representativeNote;
            this.isNewNot = false;
        },
        changeVisitorEmail() {
            if (this.editVisitorTimer) clearTimeout(this.editVisitorTimer);
            const email = this.editVisitorPropertyValue;
            this.activeConversation.email = this.editVisitorPropertyValue;
            this.editVisitorTimer = setTimeout(() => {
                const c = this.activeConversation;
                if (validateEmail(email)) {
                    if (c) {
                        const visitorId = typeof c.visitor === "object" ? c.visitor._id : c.visitor;
                        log("email updating", email);
                        sendSocketMessage("user visitor-info-updated", {
                            siteId: this.site._id,
                            conversationId: this.activeConversation._id,
                            visitorId,
                            fullname: c.fullname,
                            email,
                        });
                        this.$toasted.show(this.$t("message.visitorEmailUpdated"), {
                            duration: 3000,
                            position: "top-center",
                        });
                    }
                } else {
                    this.$toasted.error(this.$t("message.visitorEmailIsNotValid"), {
                        duration: 3000,
                        position: "top-center",
                    });
                }
            }, 1000);
        },
        changeVisitorUsername() {
            if (this.editVisitorTimer) clearTimeout(this.editVisitorTimer);
            this.activeConversation.fullname = this.editVisitorPropertyValue;

            this.editVisitorTimer = setTimeout(() => {
                const c = this.activeConversation;
                this.activeConversation.fullname = this.activeConversation.fullname
                    .trim()
                    .toLowerCase()
                    .split(" ")
                    .map((x) => x.trim())
                    .filter((x) => x.length > 0)
                    .map((x) => capitalize(x))
                    .join(" ");
                const visitorId = typeof c.visitor === "object" ? c.visitor._id : c.visitor;
                sendSocketMessage("user visitor-info-updated", {
                    siteId: this.site._id,
                    conversationId: this.activeConversation._id,
                    visitorId,
                    fullname: this.activeConversation.fullname,
                    email: c.email,
                });
                this.$toasted.show(this.$t("message.visitorNameUpdated"), {
                    duration: 3000,
                    position: "top-center",
                });
            }, 1000);
        },
        changeCustomLogin() {
            if (this.editVisitorTimer) clearTimeout(this.editVisitorTimer);
            const key = this.editVisitorProperty;
            const val = this.editVisitorPropertyValue;
            this.editVisitorTimer = setTimeout(() => {
                const customLoginInfos = this.activeConversation.customLoginInfos.map((item) => {
                    if (item.input === key) {
                        item.value = val;
                    }
                    return item;
                });
                this.updateCustomLoginInfo({
                    conversationId: this.activeConversation._id,
                    customLoginInfos,
                });
                this.$message.success(this.$t("chatbotv2.saveSuccessfully"));
            }, 1000);
        },
        async getVisitorFromId(id) {
            const { data } = await this.getVisitor(id);
            this.visitor = data;
        },
        removeVisitorAttr(attrId) {
            this.deleteContactProperty({ visitorId: this.visitor._id, contactPropertyId: attrId }).then(() => {
                this.visitor.contactProperties = this.visitor.contactProperties.filter((c) => c._id !== attrId);
            });
        },
        openDelegateAssignment() {
            this.modalDelegateAssignment = true;
        },
        joinTheChat(conversation, minimized = false, autoAssign = false) {
            if (this.fakeMode) {
                this.viewFakeConversation(fakeConversation());
                return;
            }
            this.multiBeepConversation([conversation._id]);
            this.joinConversation({
                conversation,
                observe: false,
                minimized: minimized,
                autoAssign: autoAssign,
                sendToSocket: true,
            });
        },
    },
    watch: {
        activeConversation(newConversation, oldConversation) {
            if (oldConversation.visitor._id !== newConversation.visitor._id) {
                this.getVisitorFromId(newConversation.visitor._id);
                this.getLastNote(newConversation.visitor._id).then((note) => {
                    this.lastNote = note;
                });
            }
        },
        isCardVisible(newVal) {
            if (newVal) {
                this.$nextTick(() => {
                    this.isCardVisible = false;
                });
            }
        },
    },
};
</script>
<style>
#chatCard .details-chat-card .user-detail .input-value .ant-input {
    height: 24px !important;
    padding: 0px 7px !important;
}
</style>
<style lang="scss" scoped>
.headtitle {
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .text {
        font-size: 16px;
        font-weight: 600;
        font-family: Poppins;
    }
}

.rep-note-element {
    margin-bottom: 10px;
}

.flex {
    display: flex;

    &.w-full {
        width: 100%;
    }

    &.centered {
        align-items: center;
    }

    &.space-between {
        justify-content: space-between;
    }
}

.old-note {
    display: flex;
    align-items: center;
    font-size: 14px;
    cursor: pointer;
}

.old-note-desc {
    padding: 5px 10px;
    border: 0.5px solid #ffa800;
    margin-top: 5px;
    border-radius: 4px;

    .top-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .agent-name {
        font-size: 14px;
        font-weight: bold;
        color: #ffa800;
    }

    .old-note-date {
        font-size: 12px;
        font-weight: normal;
        color: #ffa800;
    }

    .agent-note {
        font-size: 12px;
    }
}

.classic-button {
    border: none;
    background-color: #ffa80040;
    color: #ffa800;
    font-family: Poppins;
    font-weight: 600 !important;
    font-size: 14px;
    cursor: pointer;
    padding: 3px 10px;
    border-radius: 6px;
    display: flex;
    justify-content: center;
    align-items: center;

    &.visitor-attr {
        font-size: 12px !important;
        padding: 1px 10px !important;
        font-weight: 400 !important;
    }

    &.open-note {
        padding: 3px !important;
        margin-right: 5px;

        span.material-icons {
            font-size: 16px !important;
        }
    }
}

.userInfoWidget {
    max-width: 500px;
    height: calc(100vh - 180px);
    overflow-y: auto;

    ::-webkit-scrollbar {
        display: none;
    }

    :last-child {
        margin-bottom: 0 !important;
    }

    #chatCard {
        z-index: 9;
        background-color: #ffffff;
        padding: 15px 15px;
        margin-bottom: 10px;
        border-radius: 6px;

        .details-chat-card {
            &:first-child {
                margin-top: 0px !important;
            }

            .user-detail {
                display: flex;
                align-items: center;
                margin-top: 5px;

                .input-value {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    width: 100%;
                    overflow: hidden;

                    .disableShortcut {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        width: 100%;
                    }

                    .edited-input {
                        display: flex;
                        justify-content: start;
                        align-items: center;
                        width: 80%;
                        margin-right: 5px;
                    }

                    .w-full {
                        text-overflow: ellipsis;
                        overflow: hidden;
                        width: 75%;
                        white-space: nowrap;
                    }
                }

                .icon {
                    margin-right: 8px;
                    color: #ffa800;
                    cursor: text;
                }
            }
        }
        .user-detail-name {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
}

.rep-note-actions {
    display: flex;
    justify-content: end;
}

.copyButton {
    border: transparent;
    background: transparent;
    color: green;
}

.removeButton {
    background: transparent;
    border: transparent;
    color: red;
}

#forwardButton {
    border: none;
    background: rgba(255, 168, 0, 0.2509803922) !important;
    color: #ffa800;
    font-weight: 600 !important;
    cursor: pointer;
    padding: 3px 7px !important;
    border-radius: 6px;
    height: 26px !important;
}

#joinButton {
    border: none;
    background: rgba(255, 168, 0, 0.2509803922) !important;
    color: #ffa800;
    font-weight: 600 !important;
    cursor: pointer;
    padding: 3px 7px !important;
    border-radius: 6px;
}
</style>
<style lang="scss">
.forwardRepresentativeModal {
    .ant-modal {
        width: 80% !important;
    }
}

.whatsapp-channel-info {
    width: 22px;
    height: 22px;
    margin: 3px 5px 3px 2px;
}
#user-phone-number {
    a {
        color: rgba(0, 0, 0, 0.65);
    }
}
</style>
